import React, {useEffect, useState} from "react";
import {FaRegUser} from "react-icons/fa";
import {MdOutlineShoppingCart} from "react-icons/md";
import {CgShoppingBag} from "react-icons/cg";
import apiRequests from "../../Component/axios/config/config";
import {Link, useNavigate} from "react-router-dom";
import LoadingSpan from "../../Component/Loading/LoadingSpan";


export default function Dashboard() {


    const [loading, setLoading] = useState(true);

    const [data, setData] = useState({
        user: 0,
        product: 0,
        category: 0,
    });

    const dataInBox = [
        {
            title: "Users",
            icon: <FaRegUser/>,
            data: data.user,
            link: "/user"
        },
        {
            title: "Product",
            icon: <MdOutlineShoppingCart/>,
            data: data.product,
            link: "/my-product"
        },
        {
            title: "Category",
            icon: <CgShoppingBag/>,
            data: data.category,
            link: "/category"
        }
    ]

    const navigate = useNavigate();
    useEffect(() => {

        setLoading(true)
        apiRequests.get("/api/admin/v1/Dashboard-API")
            .then((res) => {
                setData({
                    user: res.data.data.user,
                    product: res.data.data.product,
                    category: res.data.data.category
                })
            })
            .catch((err) => {
                if (err.status === 401 || err.status === 403) {
                    navigate("/login");
                }
            })
            .finally(() => setLoading(false));

    }, []);


    return (


        <div className="p-6">

            <div className="text-3xl font-bold text-gray-800 mb-6">
                Dashboard
            </div>

            <div className="flex gap-5 flex-wrap">

                {dataInBox.map((item, index) => (
                    <Link key={item.link} to={item.link}
                          className="bg-marginColor-shade2 transition duration-300 hover:shadow-2xl hover:-translate-y-3 flex flex-col gap-2 p-3 rounded-lg shadow-xl w-52">

                        <div className="flex gap-2 items-center ">
                            <span className="text-baseColor-button text-2xl">{item.icon}</span>
                            <span className="text-2xl">{item.title}</span>

                        </div>

                        <div className="font-bold  text-3xl">
                            {loading ?
                                <LoadingSpan/>
                                :
                                item.data}
                        </div>

                    </Link>

                ))}


            </div>
        </div>
    )
}